import ComoAgentsList from "../Components/ComoAgents/ComoAgentsList";

const ComoAgentsListPage = () => {
  return (
    <div>
      <ComoAgentsList />
    </div>
  );
};

export default ComoAgentsListPage;
